import React from "react"

interface SectionHeadingProps {
    eyebrow?: string
    title: React.ReactNode
    lead?: React.ReactNode
    center?: boolean
    as?: "h2" | "h3"
}

/**
 * Shared landing page section heading: eyebrow label, title and lead paragraph.
 */
export const SectionHeading: React.FC<SectionHeadingProps> = ({
    eyebrow,
    title,
    lead,
    center = true,
    as: Tag = "h2"
}) => (
    <div className={`lp-heading${center ? " lp-heading--center" : ""}`} data-reveal="">
        {eyebrow && <span className="lp-eyebrow">{eyebrow}</span>}
        <Tag className="lp-title">{title}</Tag>
        {lead && <p className="lp-lead">{lead}</p>}
    </div>
)
